import CircledTick from './circled-tick';

export * from './circled-tick';
export default CircledTick;
